import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';

const WallModel = () => {
    const { gl } = useThree ();

    const [isStorageRightWall, setIsStorageRightWall] = useState(false);

    const wallThickness = 0.005;
    const cbFrontBackWallOffset = 0.16;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    
    const textureObj = useMemo(() => {

        let similarSidingTextures = getSimilarTexture(params.wallTexture)
        let similarWainscotTextures = getSimilarTexture(params.wainscotTexture)

        const texture = const_var.wallTextureObj?.[similarSidingTextures]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[similarWainscotTextures]?.clone();

        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = Math.PI/-2;
            else metalTexture.rotation = 0;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    const offset = useMemo(() => {
        if(params.lean_p_d % legDistance === 0 || params.lean_p_d - params.leftLeanStoragePosition - parseInt(params.add_storage) < legDistance / 2) return 0.15;
        else return 0;
    }, [params.lean_p_d, legDistance, params.leftLeanStoragePosition, params.add_storage])
    
     // left Lean Front storage inWall - CSG
    const storageRightWallModelObj = useMemo(() => {
        let mainWall;
        let innerWall;
        let wainscotWall;
        
        const storageSideWallModel = new THREE.Shape();
        storageSideWallModel.moveTo(params.lean_p_d / 2 - parseInt(params.add_storage) - offset, 0);
        storageSideWallModel.lineTo(params.lean_p_d / 2 - parseInt(params.add_storage) - offset, params.lean_p_h + (params.lean_p_w  - 0.05)* params.b_l_t_r_p / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0));
        storageSideWallModel.lineTo(params.lean_p_d / 2 + cbFrontBackWallOffset - wallThickness, params.lean_p_h + (params.lean_p_w  - 0.05)* params.b_l_t_r_p / 12 + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0));
        storageSideWallModel.lineTo(params.lean_p_d / 2 + cbFrontBackWallOffset - wallThickness, 0);
        storageSideWallModel.closePath();

        let verticalHorizontalPosStorageS = {"x": params.p_w / -2 - 0.03,"y" : (params.p_w_c_n ? 2.935 : 0), "z" : -(params.lean_p_d / 2 - parseInt(params.add_storage))}
        let verticalHorizontalRotStorageS = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let patternLengthStorageS = params.lean_p_h + ((params.b_l_t_r_p/12) * params.lean_p_w) + (params.p_w_c_n ? -2.935 : 0) + (params.p_r_s === 1 ? const_var.roofRegularDst * 2 : 0)
        let patternDepthStorageS = parseInt(params.add_storage) + 0.16
   
        const meshSideStorageWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthStorageS, isPattern), extrudeSettings(patternDepthStorageS)));
        const meshFrontStorageInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageSideWallModel, extrudeSettings(wallThickness)), new THREE.MeshStandardMaterial({ color: 'brown' }))
        const meshFrontStorageInDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('leftLeanStorageRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        let mesStoragehWallModel_TempS = meshSideStorageWallModelPattern.clone();
        mesStoragehWallModel_TempS.position.set(verticalHorizontalPosStorageS.x,verticalHorizontalPosStorageS.y,verticalHorizontalPosStorageS.z);
        mesStoragehWallModel_TempS.rotation.set(verticalHorizontalRotStorageS.x,verticalHorizontalRotStorageS.y,verticalHorizontalRotStorageS.z);
        mesStoragehWallModel_TempS.updateMatrixWorld();
        
        let meshFrontStorageInnerWallModel_Temp = meshFrontStorageInnerWallModel.clone();
        meshFrontStorageInnerWallModel_Temp.rotateY(Math.PI / 2);
        meshFrontStorageInnerWallModel_Temp.position.set(-(params.p_w / 2 + 0.07), 0, 0);
        meshFrontStorageInnerWallModel_Temp.updateMatrixWorld();

        let meshFrontStorageInDelModel_Temp = meshFrontStorageInDelModel.clone();
        meshFrontStorageInDelModel_Temp.rotateY(Math.PI / 2);
        meshFrontStorageInDelModel_Temp.position.set(-params.p_w / 2 - 0.5, 0, -params.lean_p_pos - params.leftLeanStoragePosition);
        meshFrontStorageInDelModel_Temp.updateMatrixWorld();
    
        const meshFrontStorageInnerWallModel_CSG = CSG.fromMesh(meshFrontStorageInnerWallModel_Temp);
        const meshFrontStorageInDelModel_CSG = CSG.fromMesh(meshFrontStorageInDelModel_Temp);
        const meshStorageWallModel_CSGS = CSG.fromMesh(mesStoragehWallModel_TempS);
    
        const frontStorageOuterWallModel_CSG =  meshStorageWallModel_CSGS.subtract(meshFrontStorageInDelModel_CSG);
        const frontStorageInnerWallModel_CSG =  meshFrontStorageInnerWallModel_CSG.subtract(meshFrontStorageInDelModel_CSG);
   
        const CSGFrontStorageOuterWallModel = CSG.toMesh(frontStorageOuterWallModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const CSGFrontStorageInnerWallModel = CSG.toMesh(frontStorageInnerWallModel_CSG, new THREE.Matrix4(), new THREE.MeshStandardMaterial({ color: 'blue' }))

        mainWall = CSGFrontStorageOuterWallModel.geometry;
        innerWall = CSGFrontStorageInnerWallModel.geometry;

        /************** cutting hole in wainscot using CSG for Storage Right***************/
        let wainscotVerticalHorizontalPosStorageS = {"x": params.p_w / -2 - 0.06,"y" : 0, "z" : -params.lean_p_d / 2 + parseInt(params.add_storage)}
        let wainscotVerticalHorizontalRotStorageS = {"x":0,"y" : Math.PI,"z" : Math.PI / 2}
        let lengthPatternStorageS = 3
        let depthPatternStorageS = patternDepthStorageS

        const meshStorageRightWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternStorageS, isPattern), extrudeSettings(depthPatternStorageS)));
        let meshStorageRightWainscotModel_Temp = meshStorageRightWainscotModel.clone();
        meshStorageRightWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosStorageS.x,wainscotVerticalHorizontalPosStorageS.y,wainscotVerticalHorizontalPosStorageS.z);
        meshStorageRightWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotStorageS.x,wainscotVerticalHorizontalRotStorageS.y,wainscotVerticalHorizontalRotStorageS.z);
        meshStorageRightWainscotModel_Temp.updateMatrixWorld();

        const meshStorageRightWainscotModel_CSG = CSG.fromMesh(meshStorageRightWainscotModel_Temp);

        const storageRightWainscotModel_CSG = meshStorageRightWainscotModel_CSG.subtract(meshFrontStorageInDelModel_CSG);

        const CSGStorageRightWainscotModel = CSG.toMesh(
            storageRightWainscotModel_CSG,
            new THREE.Matrix4()
        )

        wainscotWall = CSGStorageRightWainscotModel.geometry;

        return {mainWall, innerWall, wainscotWall}

    }, [params.wallTexture,params.p_d,params.add_storage_check, params.lean_p_pos, params.p_v_w, params.p_w, params.leftLeanStoragePosition, params.b_l_t_r_p, params.lean_p_h, params.lean_p_d, params.lean_p_w, params.p_r_s, params.add_storage, const_var.newDoorsArray, params.p_w_c_n, isPattern]);


    /*******************************  ****************************/
   
    useMemo(() => {
        let array = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'c_b_l_w' && item.height > params.lean_p_h);
        for(let i=0; i<array.length; i++) {
            let item = array[i];
            const doorPositionX = item.positionX;
            const doorWidth = item.width
            const LeftStoragePos = params.lean_p_pos - params.lean_p_d / 2
            const RightStoragePos = params.lean_p_pos - params.lean_p_d / 2 + parseInt(params.add_storage)
            if((LeftStoragePos >= (doorPositionX - doorWidth / 2)) && (RightStoragePos <= (doorPositionX + doorWidth / 2))){
                setIsStorageRightWall(true)
                return;
            } 
            setIsStorageRightWall(false)
        }

    }, [const_var.newDoorsArray, params.lean_p_pos, params.lean_p_d, params.add_storage, params.lean_p_h])

    return (
        <>
            {params.p_w_c_n == true && params.add_storage_check && storageRightWallModelObj?.wainscotWall &&
                <mesh name="L_L_L_S_W_wainscot" geometry={storageRightWallModelObj?.wainscotWall} position={[0.005,0,0]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"leftlean"} />
                </mesh>
            }
            {params.add_storage_check && storageRightWallModelObj?.mainWall &&
                !isStorageRightWall &&
                    <mesh name="L_L_R_S_W" geometry={storageRightWallModelObj?.mainWall} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern} visibleSection={"leftlean"} />
                    </mesh>
            }
            {params.add_storage_check && storageRightWallModelObj?.innerWall &&
                <mesh name="storage-right" geometry={storageRightWallModelObj?.innerWall} position={[-wallThickness - 0.01, 0, 0]}>
                    <MaterialInnerWall texture={texture} visibleSection={"leftLean"} />
                </mesh>
            }
        </>
    )
}

export default WallModel